import base from './base'
import courses from './courses'
import finalquiz from './finalquiz'
import imprint from './imprint'
import rewardsModal from './rewardsModal'
import login from './login'
import nav from './nav'
import profile from './profile'
import profiler from "./profiler";
import installationVideos from './installationVideos'

export default {
    base,
    courses,
    finalquiz,
    imprint,
    login,
    nav,
    profile,
    rewardsModal,
    installationVideos,
    profiler
}
